module.exports = __webpack_public_path__ + "static/media/add-icon.0a0c40ee.svg";